const sensitiveFieldPattern = /password|token|secret|authorization|cookie|email|phone|address|customer|firstname|lastname/i;

function redactMessage(value) {
  const message = value.length > 600 ? value.slice(0, 600) + '...[truncated]' : value;
  return message
    .replace(/Bearer\s+\S+/gi, 'Bearer [redacted]')
    .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
    .replace(/https?:\/\/[^\s"<>]+/gi, '[url]')
    .replace(/\b\d[\d ()+.-]{7,}\d\b/g, '[number]')
    .replace(/((?:token|password|secret|authorization|cookie)\s*[=:]\s*)\S+/gi, '$1[redacted]');
}

// Only collect error fields, never the submitted quote, headers or full response.
export function getHttpErrorDetails(error) {
  if (!error || !error.response) {
    return undefined;
  }

  const config = error.config || {};
  let endpoint;
  try {
    const url = new URL(config.url, config.baseURL || window.location.href);
    endpoint = url.origin + url.pathname;
  } catch (ignored) {
    endpoint = '[unavailable]';
  }

  const response = error.response.data;
  const details = {
    operation: error.visualizerOperation,
    method: typeof config.method === 'string' ? config.method.toUpperCase() : undefined,
    endpoint: endpoint.slice(0, 500),
    status: error.response.status,
    responseType: typeof response,
  };

  if (response && typeof response === 'object' && !Array.isArray(response)) {
    details.responseMessages = ['code', 'message', 'error', 'title', 'detail'].reduce((messages, key) => {
      if (typeof response[key] === 'string') {
        messages[key] = redactMessage(response[key]);
      }
      return messages;
    }, {});
    if (response.errors && typeof response.errors === 'object') {
      details.validationFields = Object.keys(response.errors).slice(0, 15)
        .map((key) => sensitiveFieldPattern.test(key) ? '[redacted-field]' : redactMessage(key).slice(0, 100));
    }
  } else if (typeof response === 'string') {
    // HTML error pages can contain echoed request data; do not include them.
    details.responseFormat = /<\s*[a-z!]/i.test(response) ? 'html' : 'text';
  }

  // JSON escaping and non-ASCII text can be much larger than their character count.
  const serializedDetails = JSON.stringify(details);
  if (new Blob([serializedDetails]).size > 8000) {
    delete details.responseMessages;
    delete details.validationFields;
    details.responseDetailsOmitted = 'size-limit';
  }

  return details;
}
